export default "__VITE_PUBLIC_ASSET__9c1c6aa3__"